import React from "react";

import PasswordResetForm from "components/ForgotPassword/PasswordResetForm";

const PasswordReset = () => {
  return <PasswordResetForm />;
};

export default PasswordReset;
